<script setup lang="ts">

interface Props {
    color?: 'normal' | 'main' | 'light' | 'dark'
    size?: 'medium' | 'large'
    alignment?: 'left' | 'center' | 'right' | 'justify'
}
const colorClass = {
    normal: '',
    main: 'text-orange-600',
    light: 'text-white',
    dark: 'text-black'
}
const sizeClass = {
    medium: 'text-xl',
    large: 'text-3xl'
}
const alignmentClass = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right',
    justify: 'text-justify',
}
const { color = 'normal', size = 'medium', alignment } = defineProps<Props>()
</script>

<template>
    <h1 :class="[colorClass[color], sizeClass[size], alignment && alignmentClass[alignment]]" class="font-bold mb-3">
        <slot />
    </h1>
</template>